// Readonly workspaces keep personal backups locally, outside the mirrored Yjs document.
const openDatabase = () => new Promise((resolve, reject) => {
  const request = indexedDB.open('chwala-local-backups', 1);
  request.onupgradeneeded = () => request.result.createObjectStore('backups', {keyPath: 'key'});
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error);
});

const transaction = async (mode, operation) => {
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('backups', mode);
    const request = operation(tx.objectStore('backups'));
    tx.oncomplete = () => { db.close(); resolve(request.result); };
    tx.onabort = () => { db.close(); reject(tx.error || request.error); };
    tx.onerror = () => { db.close(); reject(tx.error || request.error); };
  });
};

export const getLocalBackups = async workspaceId => {
  const entries = await transaction('readonly', store => store.getAll());
  return entries.filter(entry => entry.workspaceId === workspaceId).map(entry => entry.backup)
    .sort((a, b) => new Date(b.date) - new Date(a.date));
};
export const storeLocalBackup = (workspaceId, backup) => transaction('readwrite', store =>
  store.put({key: `${workspaceId}:${backup.id}`, workspaceId, backup}));
export const deleteLocalBackup = (workspaceId, id) => transaction('readwrite', store =>
  store.delete(`${workspaceId}:${id}`));
